import {Component, OnInit, Output, ViewEncapsulation, EventEmitter} from '@angular/core';
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {SettingsService} from "../../../services/settings.service";
import {SettingModel} from "../../../models/setting.model";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginFormComponent implements OnInit {
  voteEnabled: SettingModel;
  public loginForm = this._formBuilder.group({
    email: [
      '',
      [
        Validators.email
      ]
    ]
  });
  @Output() errorText = new EventEmitter<string | boolean>();

  constructor(
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _settingsService: SettingsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.voteEnabled = await this._settingsService.getBySlug('vote-enabled').toPromise();
    if (!this.voteEnabled.enabled) {
      this.loginForm.controls['email'].disable();
    }
    if (this.loginForm.controls.email.value === '') {
      this.errorText.emit('Email-ul trebuie completat!');
    }
    this.loginForm.controls.email.valueChanges.subscribe(() => {
      if (this.loginForm.controls.email.value === '') {
        this.errorText.emit('Email-ul trebuie completat!');
      } else if (this.getEmailError('email')) {
        this.errorText.emit('Email-ul este invalid!');
      } else {
        this.errorText.emit(true);
      }
    });
  }

  get value(): Record<string, string> {
    return this.loginForm.value;
  }

  getEmailError(errorCode: string): boolean {
    return this.loginForm.controls.email.hasError(errorCode);
  }
}
